import { render, staticRenderFns } from "./safe.md?vue&type=template&id=33d6e7f8&"
import script from "./safe.md?vue&type=script&lang=js&"
export * from "./safe.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d6e7f8')) {
      api.createRecord('33d6e7f8', component.options)
    } else {
      api.reload('33d6e7f8', component.options)
    }
    module.hot.accept("./safe.md?vue&type=template&id=33d6e7f8&", function () {
      api.rerender('33d6e7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/scatter/safe.md"
export default component.exports